import { css } from "azure-devops-ui/Util";
import React from "react";
import { useIntersection } from "../../../common/hooks/useintersection";
import { IRectangle } from "../../types/layout";

export interface IPlaceholderProps {
  className?: string;
  rect: IRectangle;
}

export function Placeholder(props: IPlaceholderProps): React.ReactElement {
  const {
    className,
    rect: { height, left, top, width }
  } = props;

  return <div className={css("placeholder", className, "rounded-6")} style={{ height, left, top, width }}></div>;
}

export interface IPlaceholderExProps extends IPlaceholderProps {
  root?: React.RefObject<HTMLElement>;
  onVisibilityChange: (visible: boolean) => void;
}

export function PlaceholderEx(props: IPlaceholderExProps): React.ReactElement {
  const {
    className,
    onVisibilityChange,
    rect: { height, left, top, width },
    root
  } = props;

  const intersectionOptions = React.useRef<IntersectionObserverInit>({ root: root && root.current, rootMargin: "2000px" });
  const photoElement = React.useRef<HTMLDivElement>(null);

  // Observe the visibility of the photoElement.
  useIntersection(
    photoElement,
    React.useCallback((entries) => onVisibilityChange(entries[0].isIntersecting), [onVisibilityChange]),
    intersectionOptions.current
  );

  return <div className={css("placeholder", className, "rounded-6")} ref={photoElement} style={{ height, left, top, width }} />;
}
